export default __webpack_public_path__ + "static/media/edit-btn.5c67f6a4.svg";